export const resources = {
  en: {
    common: {
      close: 'Close',
      language: {
        current: 'Current language',
        english: 'ENG',
        korean: 'KOR',
      },
      openAllMenu: 'Open all menu',
      openMobileMenu: 'Open mobile menu',
      pagination: {
        currentPage: '{{page}} page, current page',
        nextPage: 'Next page',
        page: '{{page}} page',
        previousPage: 'Previous page',
      },
      pageTop: 'Back to top',
    },
    footer: {
      builtBy: 'Built by newzest studio.',
      copyright: 'Copyright 2026 Kookje TNC Co., Ltd. All rights reserved.',
      effectiveDate: 'Effective date',
      infoLabels: {
        E_MAIL: 'E-MAIL',
        FAX: 'FAX',
        TEL: 'TEL',
        address: 'Address',
        businessRegistrationNumber: 'Business Registration No.',
        companyName: 'Company',
        representative: 'CEO',
      },
      infoValues: {
        E_MAIL: 'kjtnc@kookje2001.com',
        FAX: '031-551-2253',
        TEL: '1661-8860',
        address:
          'Hyundai Premier Campus AA 926-928, 20 Dasansunhwan-ro, Namyangju-si, Gyeonggi-do, Republic of Korea',
        businessRegistrationNumber: '132-81-86022',
        companyName: 'Kookje TNC Co., Ltd.',
        representative: 'Kim Ki-baek',
      },
      policies: {
        emailRefusal: 'Email Collection Refusal',
        privacy: 'Privacy Policy',
        terms: 'Terms of Use',
      },
    },
    navigation: {
      dynamicCategoryDescription: '{{category}} items are organized and displayed by category.',
      homeLinkLabel: 'Go home',
      labels: {
        'CO₂ 자연냉매': 'CO₂ Natural Refrigerant',
        CEO인사말: 'CEO Message',
        공사실적: 'Project Records',
        '공조 기계설비': 'Mechanical HVAC',
        '공조기 리필형 필터': 'AHU Refill Filter',
        공조설비: 'HVAC Facilities',
        기계설비: 'Mechanical Systems',
        '기술설계 전문시공': 'Technical Design & Specialized Construction',
        기술자료: 'Technical Materials',
        '내치형 냉동 쇼케이스': 'Built-in Frozen Showcase',
        '냉동·냉장 시스템': 'Refrigeration System',
        냉동냉장: 'Refrigeration',
        냉각탑: 'Cooling Tower',
        냉난방설비: 'Heating & Cooling Facilities',
        '경영이념·연혁': 'Philosophy & History',
        '농수산 저온창고': 'Agricultural & Fisheries Cold Storage',
        '모터 직결제어 시스템': 'Motor Direct Control System',
        보일러: 'Boiler',
        시공사례: 'Project Cases',
        '오픈 쇼케이스 도어': 'Open Showcase Door',
        '운영 컨설팅': 'Operations Consulting',
        언론보도: 'Media Coverage',
        '에너지 솔루션': 'Energy Solution',
        위치안내: 'Location',
        위생설비: 'Plumbing & Sanitary Systems',
        '웹 카탈로그': 'Web Catalog',
        '유니트 쿨러': 'Unit Cooler',
        유지보수: 'Maintenance',
        유통: 'Retail',
        자동제어: 'Automatic Control',
        정보지원: 'Information Support',
        제빙: 'Ice Making',
        조직도: 'Organization',
        터보냉동기: 'Turbo Chiller',
        '프리미엄 와인셀러': 'Premium Wine Cellar',
        하이얼캐리어: 'Haier Carrier',
        '홈으로 이동': 'Go home',
        카달로그: 'Catalog',
        '특허·인증': 'Patents & Certifications',
        홍보영상: 'Promotional Videos',
        회사소개: 'About Us',
        'CO₂ 컴프레서 랙 시스템': 'CO₂ Compressor Rack System',
      },
      menuDescriptions: {
        co2NaturalRefrigerant: 'CO₂ natural refrigerant solutions are organized for quick access.',
        company: 'Company overview and key information are organized under About Us.',
        energySolution: 'Energy solutions are organized by category.',
        informationSupport:
          'Boards, resources, and video menus are grouped under Information Support.',
        mechanicalHvac: 'Mechanical and HVAC services are organized by facility area.',
        refrigerationSystem: 'Refrigeration system services are organized by application.',
      },
    },
    quickMenu: {
      catalog: 'Catalog',
      location: 'Location',
      'promotional-video': 'Videos',
      promotionalVideo: 'Videos',
    },
    about: {
      certification: {
        breadcrumb: 'Patents and certifications path',
        categories: {
          certification: 'Certifications & Awards',
          'patent-design': 'Patents & Designs',
        },
        empty: 'No patent or certification information has been registered.',
        errorTitle: 'Could not load patent and certification information.',
        headings: {
          awards: 'Certifications & Awards',
          patents: 'Patents & Design Registrations',
        },
        hero: {
          backgroundAlt: 'Kookje TNC patents and certifications page hero visual',
          description:
            'Our accumulated technical capabilities have led to a broad portfolio of patents and certifications.\nKookje TNC strengthens trust through verified technology.',
          eyebrow: 'Patents & Certifications',
          title: 'Patents and certifications\nthat prove technical reliability',
        },
        imageAlt: '{{title}} evidence image',
        loading: 'Loading patent and certification information.',
      },
      greeting: {
        breadcrumb: 'CEO message path',
        hero: {
          backgroundAlt: 'Kookje TNC CEO message page hero visual',
          description:
            'We respond quickly while strengthening our technical competitiveness.\nKookje TNC will continue growing together with customers.',
          eyebrow: 'CEO Message',
          title: 'Fast response and technical innovation\ncreating customer value and growth',
        },
        message: {
          closing: 'Thank you.',
          companyLabel: 'CEO, Kookje TNC',
          introHeading: 'Hello, I am Kim Ki-baek, CEO of Kookje TNC.',
          paragraphs: [
            'Since its founding in 2001, Kookje TNC has built customer trust through accumulated experience and specialized expertise in refrigeration and cold storage systems.',
            'We have continued working to deliver the value customers need, from precise design, reliable construction, and systematic maintenance to technical consulting, commissioned training, and precision diagnostics. We are also expanding our business scope through the import and sale of unit coolers and showcases to provide broader solutions.',
            'Kookje TNC will remain a trusted partner that improves energy efficiency and reduces management costs through a responsible attitude and a steady commitment to technology. We will prepare for our customers’ future together while fulfilling our environmental and social responsibilities as a refrigeration specialist.',
          ],
          portraitAlt: 'Kim Ki-baek, CEO of Kookje TNC',
          signatureAlt: 'Signature of Kim Ki-baek, CEO of Kookje TNC',
          title: 'With technology and responsibility,\nwe prepare a better future for customers.',
        },
      },
      history: {
        breadcrumb: 'Philosophy and history path',
        empty: 'No history information has been registered.',
        errorTitle: 'Could not load history information.',
        esg: {
          pillars: {
            environment:
              'Reducing carbon and greenhouse gas emissions\nwhile improving energy efficiency',
            governance:
              'Establishing sound systems, increasing transparency,\nand fulfilling social responsibility as a trusted company',
            social: 'Respecting employees’ rights\nand protecting the value of their lives',
          },
          title: 'ESG Management',
        },
        hero: {
          backgroundAlt: 'Kookje TNC history page hero visual',
          description:
            'Kookje TNC has grown with a clear philosophy.\nBeyond today’s achievements, we are preparing a better tomorrow.',
          eyebrow: 'Philosophy & History',
          title: 'Kookje TNC designs\na sustainable tomorrow',
        },
        imageAlt: '{{year}} {{title}} history image',
        loadMore: 'Load more',
        loading: 'Loading history information.',
        practice: {
          principles: {
            fundamentals: 'A trusted company that keeps the basics\nand values principles',
            people: 'A company that values people\nand helps them use their capabilities',
            technology:
              'A creative company that continues\ntechnology development for future needs',
          },
          title: 'Practice Principles',
        },
        showingCount: 'Showing {{visible}} / {{total}}',
      },
      location: {
        breadcrumb: 'Locations path',
        companyInfo: {
          address: {
            label: 'Head Office Address',
            value:
              'Hyundai Premier Campus AA 926-928, 20 Dasansunhwan-ro, Namyangju-si, Gyeonggi-do, Republic of Korea',
          },
          email: 'Email',
          fax: 'Fax',
          phone: 'Main Phone',
          title: 'Company Information',
        },
        controls: {
          currentLocation: 'Move to current location',
          geolocationBlocked: 'Current location is available only over HTTPS or localhost.',
          geolocationUnsupported: 'This browser does not support current location.',
          locatingApproximate:
            'Showing your approximate location. Estimated accuracy is about {{accuracy}}m.',
          locationAccuracyLow:
            'The current location accuracy is too low. Please try again outdoors.',
          locationPermissionDenied:
            'Location permission is blocked in the browser, so your current location could not be retrieved.',
          locationTimeout: 'Current location timed out. Please try again later.',
          locationUnavailable: 'Your current location cannot be determined on this device.',
          locationUnknown:
            'Could not retrieve your current location. Please check browser permissions and network status.',
          zoomIn: 'Zoom in map',
          zoomOut: 'Zoom out map',
        },
        hero: {
          backgroundAlt: 'Kookje TNC location page hero visual',
          description:
            'Find convenient directions to Kookje TNC.\nWe stay close to customers wherever they need us.',
          eyebrow: 'Locations',
          title: 'Meet Kookje TNC\ncloser to you',
        },
        labels: {
          address: 'Address',
          directions: 'Directions',
          phone: 'Phone',
        },
        map: {
          apiKeyMissing: 'The Kakao Map API key is not configured, so the map cannot be displayed.',
          geocodeFailed:
            'The address could not be converted to coordinates. Please check again later.',
          loadFailed: 'Could not load Kakao Map. Please check the network or API settings.',
          loading: 'Loading the map.',
          pending: 'Checking the Kakao Map SDK and address information.',
          tabsLabel: 'Select office location',
          title: 'Directions',
          unavailable: 'The map cannot be displayed.',
        },
        offices: {
          factory: {
            addressLine1: 'Building 3, 7 Jingwansandan-ro 70beon-gil, Jingeon-eup,',
            addressLine2: 'Namyangju-si, Gyeonggi-do',
            busDescription: '15-minute walk from Baeyang-ri stop',
            busTitle: 'Bus 9',
            label: 'Factory',
          },
          guri: {
            addressLine1: '348 Achasan-ro, Guri-si, Gyeonggi-do',
            busDescription: '4-minute walk from Guri Police Station stop',
            busTitle: 'Bus 95',
            label: 'Guri Branch',
            subwayDescription: '12-minute walk from Exit 1',
            subwayTitle: 'Jangja Lake Park Station (Line 8)',
          },
          gwangju: {
            addressLine1: '579-1 Cheonbyeonuha-ro, Buk-gu, Gwangju, Jungang Refrigeration',
            busDescription1: '2-minute walk from Gonggu-ui-geori stop',
            busDescription2: '6-minute walk from Je2 Gwangcheon Bridge stop',
            busTitle1: 'Songjeong 98',
            busTitle2: 'Ilgok 38',
            label: 'Gwangju Office',
          },
          headquarters: {
            addressLine1: 'Hyundai Premier Campus AA 926-928,',
            addressLine2: '20 Dasansunhwan-ro, Namyangju-si, Gyeonggi-do',
            busDescription: '3-minute walk from Donong High School stop',
            busTitle: 'Bus 95',
            label: 'Head Office',
            subwayDescription: '20-minute walk from Exit 1',
            subwayTitle1: 'Donong Station (Gyeongui-Jungang Line)',
            subwayTitle2: 'Dasan Station (Line 8)',
            visitSummary:
              '20-minute walk from Donong Station or Dasan Station, 3-minute walk after getting off at the Bus 95 stop',
          },
        },
        transport: {
          bus: 'Bus',
          subway: 'Subway',
        },
      },
      organization: {
        breadcrumb: 'Organization path',
        groups: {
          managementSupport: {
            label: 'Management Support\nDivision',
            teams: {
              managementAdministration: {
                items: ['HR / General\nAffairs', 'Accounting'],
                title: 'Management\nAdministration',
              },
              strategySupport: {
                items: ['Purchasing', 'Marketing'],
                title: 'Strategy\nSupport',
              },
            },
          },
          mechanicalEquipment: {
            label: 'Mechanical Systems\nDivision',
            teams: {
              facilityConstruction: {
                items: ['ESCO\nConstruction', 'Facility\nConstruction', 'Maintenance'],
                title: 'Facility\nConstruction',
              },
              mechanicalSales: {
                items: ['HVAC\nFacilities', 'Heating & Cooling\nFacilities', 'Solution\nSales'],
                title: 'Sales',
              },
            },
          },
          refrigerationEquipment: {
            label: 'Refrigeration Division',
            teams: {
              logisticsStorageSales: {
                items: ['PM', 'Design\nEngineering', 'Sales\nSupport'],
                title: 'Logistics &\nStorage Sales',
              },
              retailSales: {
                items: ['PM', 'Design\nEngineering', 'Integrated\nMonitoring'],
                title: 'Retail\nSales',
              },
              technicalConstruction: {
                items: ['ESCO\nConstruction', 'Technical\nConstruction', 'Sales\nSupport'],
                title: 'Technical\nConstruction',
              },
            },
          },
        },
        hero: {
          backgroundAlt: 'Kookje TNC organization page hero visual',
          description:
            'Specialists in each field work together organically.\nThrough systematic operations, we create better value.',
          eyebrow: 'Organization',
          title: 'The power of an organization\nbuilt on shared expertise',
        },
        leader: 'CEO',
        safety: 'Safety & Health\nManagement',
        title: 'Organization Structure',
      },
    },
    home: {
      constructionCases: {
        defaultCategory: 'Project Case',
        heading: {
          description: 'Explore project cases applied across diverse industrial sites.',
          eyebrow: 'PROJECT CASE',
          title: 'Kookje TNC Project Cases',
        },
        next: 'Next project case',
        previous: 'Previous project case',
      },
      featuredEquipment: {
        heading: {
          eyebrow: 'Core Equipment Portfolio',
          title: 'Kookje TNC Core Equipment Portfolio',
        },
        modal: {
          close: 'Close core equipment modal',
          imageOrder: 'Equipment image order',
          nextImage: 'Next equipment image',
          previousImage: 'Previous equipment image',
          progress: '{{current}} / {{total}} images',
        },
        next: 'Next core equipment',
        openCard: 'Open {{title}} card',
        previous: 'Previous core equipment',
      },
      hero: {
        intro: {
          bottom: 'toward sustainability',
          headingLabel: 'Beyond refrigeration, toward sustainability',
          top: 'Beyond refrigeration',
        },
        tagline: {
          firstLine: 'Sustainable engineering',
          secondLine: 'for a cooler tomorrow',
        },
      },
      solutionShowcase: {
        heading: {
          eyebrow: 'Solution',
          firstLine: 'Kookje TNC delivers',
          secondLineEmphasis: 'efficient, cost-saving solutions',
          secondLineSuffix: '',
        },
        mobileNavigationLabel: 'Mobile Kookje TNC solution slides',
        navigationLabel: 'Kookje TNC solution slides',
        slides: {
          'energy-saving': {
            description:
              'Optimized Fan and Pump inverter control technology reduces power consumption\nwhile advancing overall facility efficiency.',
            imageAlt: 'Energy optimization solution background image',
            mobileImageAlt: 'Energy optimization solution mobile background image',
            title: 'Energy Optimization Solution',
          },
          'fire-prevention': {
            description:
              'A real-time fire risk alert system builds a preventive safety management framework\nand a faster response environment.',
            imageAlt: 'Fire safety solution background image',
            mobileImageAlt: 'Fire safety solution mobile background image',
            title: 'Fire Safety Solution',
          },
          'hvac-system': {
            description:
              'We analyze heat loads and operating conditions to provide technical consulting,\nprecision design, and responsible construction for optimal GHP and EHP systems.',
            imageAlt: 'HVAC engineering background image',
            mobileImageAlt: 'HVAC engineering mobile background image',
            title: 'HVAC System Engineering',
          },
          'mechanical-engineering': {
            description:
              'With accumulated technical expertise, we precisely reflect process conditions and site environments\nto deliver consulting, detailed design, and responsible construction for mechanical systems.',
            imageAlt: 'Mechanical engineering background image',
            mobileImageAlt: 'Mechanical engineering mobile background image',
            title: 'Integrated Mechanical Engineering',
          },
        },
      },
      businessInquiry: {
        categoryOptions: {
          energySolution: 'Energy Solution',
          mechanicalHvac: 'Mechanical HVAC',
          other: 'Other',
          refrigerationSystem: 'Refrigeration System',
          serviceMaintenance: 'Maintenance / Service',
        },
        description:
          'We build collaborative partnerships with customers across retail, logistics, hospitality, and other industries.',
        effectiveDateLabel: 'Effective date',
        errors: {
          categoryLoadFailed: 'Could not load inquiry types.',
          invalidCategory: 'Please select a valid inquiry type.',
          submitFailed: 'Could not submit your inquiry. Please try again later.',
        },
        eyebrow: 'Business Inquiry',
        fields: {
          category: {
            label: 'Inquiry Type',
            placeholder: 'Select an inquiry type',
          },
          companyName: {
            label: 'Company',
            placeholder: 'Enter your company name',
          },
          contactName: {
            label: 'Contact Name',
            placeholder: 'Enter the contact name',
          },
          department: {
            label: 'Title / Department',
            placeholder: 'Enter title or department',
          },
          email: {
            label: 'Email',
            placeholder: 'Enter your email address',
          },
          message: {
            label: 'Message',
            placeholder:
              'Tell us about site conditions, required equipment scope, timeline, and review requests.',
          },
          phone: {
            label: 'Phone',
            placeholder: 'Enter your phone number',
          },
        },
        marketingConsentLabel: 'Consent to receive marketing information',
        marketingNotice:
          'You may receive information about new services, events, and newsletters. Refusing optional consent does not restrict inquiry submission.',
        optionalTag: '[Optional]',
        partnerLogosLabel: 'Key customer logos',
        privacyConsentLabel: 'Consent to collection and use of personal information',
        privacyLink: 'View Privacy Policy',
        privacyModalClose: 'Close privacy policy',
        privacyNotice:
          'We collect and use company name, contact name, phone number, email, and inquiry details to process your inquiry.\nThe information is used for consultation and replies and retained according to internal standards and applicable laws.\nIf you do not provide the required consent, inquiry submission may be restricted.',
        requiredTag: '[Required]',
        resetLabel: 'Write another inquiry',
        submitLabel: 'Submit Inquiry',
        submittingLabel: 'Submitting...',
        successDescription: 'We will send an initial response within one business day.',
        successTitle: 'Your inquiry has been submitted',
        title: 'Kookje TNC Business Inquiry',
        validation: {
          agreePrivacy: 'Please agree to the collection and use of personal information.',
          category: 'Please select an inquiry type.',
          companyName: 'Please enter your company name.',
          contactName: 'Please enter the contact name.',
          email: 'Please enter your email address.',
          emailFormat: 'Please enter a valid email address.',
          message: 'Please enter your inquiry details.',
          phone: 'Please enter your phone number.',
          phoneFormat: 'Please enter a valid phone number.',
        },
      },
    },
    promotionalVideo: {
      all: 'All',
      category: 'Promotional Video',
      detail: {
        invalidDescription: 'No promotional video identifier was provided.',
        invalidTitle: 'Invalid request.',
        listAction: 'Back to list',
        listLink: 'View promotional videos',
        loadingDescription: 'Loading the promotional video.',
        loadingTitle: 'Please wait.',
        meta: '[Promotional Video]',
        missingDescription: 'The promotional video data could not be found.',
        missingTitle: 'Could not load the promotional video.',
        navigationLabel: 'Previous and next promotional video navigation',
        nextEmpty: 'No next video.',
        nextLabel: 'Next video',
        playerLabel: '{{title}} video player area',
        previousEmpty: 'No previous video.',
        previousLabel: 'Previous video',
        videoFallback: 'A valid YouTube URL is required.',
        youtubePlayerLabel: '{{title}} YouTube player',
      },
      list: {
        breadcrumb: 'Promotional video path',
        count: 'There are {{count}} items registered.',
        empty: 'No promotional videos match the current filters.',
        filterLabel: 'Promotional video category filter',
        heroAlt: 'Promotional video page hero visual',
        heroDescription:
          'Explore Kookje TNC brand stories and technical capabilities through video.\nExperience the value of our products and business more vividly.',
        heroEyebrow: 'Promotional Video',
        heroTitle: 'Video archive of\nKookje TNC technology and value',
        loadingDescription: 'Loading promotional videos.',
        loadingTitle: 'Please wait.',
        next: 'Next',
        pageLabel: 'Promotional video pagination',
        previous: 'Previous',
        searchLabel: 'Search promotional videos',
        searchPlaceholder: 'Enter a keyword',
        sectionTitle: 'Promotional Videos',
        thumbnailAlt: '{{title}} promotional video thumbnail',
        viewDetail: '{{title}} details',
      },
    },
    constructionCase: {
      all: 'All',
      categories: {
        default: 'Project Case',
        '기계·공조 설비': 'Mechanical & HVAC Systems',
        '냉동·냉장 설비': 'Refrigeration Systems',
        '식품 매장 도어': 'Food Retail Door Installation',
        시공사례: 'Project Case',
        '열교환기 납품': 'Heat Exchanger Delivery',
        '유틸리티 배관': 'Utility Piping',
        환경개선공사: 'Store Environment Improvement',
      },
      detail: {
        categoryFallback: 'Project Case',
        clientLabel: 'Client',
        featureTitle: 'Construction Points · Features',
        galleryNext: 'Next project photo',
        galleryPrevious: 'Previous project photo',
        galleryTitle: 'Project Photos',
        invalidDescription: 'No project case identifier was provided.',
        invalidTitle: 'Invalid request.',
        listAction: 'Back to list',
        listLink: 'Back to project cases',
        loadingDescription: 'Loading project case details.',
        loadingTitle: 'Please wait.',
        locationFallback: 'Site information pending',
        locationLabel: 'Site Location',
        missingDescription: 'The project case data could not be found.',
        missingTitle: 'Could not load the project case.',
        periodLabel: 'Construction Period',
        photoAlt: '{{title}} project photo {{index}}',
        scopeTitle: 'Construction Scope',
        summaryTitle: 'Project Case',
      },
      list: {
        breadcrumb: 'Project cases path',
        categoryFilterLabel: 'Project case category filter',
        count: 'There are {{count}} project cases registered.',
        empty: 'No project cases match the current filters.',
        heroAlt: 'Project cases page hero visual',
        heroDescription:
          'Explore a wide range of projects and construction cases delivered by Kookje TNC.\nWe present results completed through accumulated experience and technical expertise.',
        heroEyebrow: 'Project Cases',
        heroTitle: 'Project cases completed\nthrough Kookje TNC trust',
        loadingDescription: 'Loading project cases.',
        loadingTitle: 'Please wait.',
        noItems: 'No project cases have been registered.',
        pageLabel: 'Project cases pagination',
        searchLabel: 'Search project cases',
        searchPlaceholder: 'Enter a keyword',
        sectionTitle: 'Project Cases',
        yearFilterLabel: 'Project case year filter',
        yearPlaceholder: 'Year',
      },
      meta: {
        client: 'Client',
      },
    },
    projectRecord: {
      all: 'All',
      categories: {
        공공기관: 'Public Sector',
        교육기관: 'Education',
        물류기업: 'Logistics',
        유통기업: 'Retail',
        일반기업: 'Corporate',
      },
      list: {
        breadcrumb: 'Project records path',
        categoryFilterLabel: 'Project record category filter',
        count: 'There are {{count}} project records registered.',
        empty: 'No project records match the current filters.',
        headers: {
          category: 'Category',
          client: 'Client',
          name: 'Project Name',
          number: 'No.',
          period: 'Construction Period',
        },
        heroAlt: 'Project records page hero visual',
        heroDescription:
          'Explore a wide range of projects and records delivered by Kookje TNC.\nWe present results completed through accumulated experience and technical expertise.',
        heroEyebrow: 'Project Records',
        heroTitle: 'Project records completed\nthrough Kookje TNC trust',
        loadMore: 'Load more (10)',
        failedTitle: 'Could not load project records.',
        loadingDescription: 'Loading project records.',
        loadingTitle: 'Please wait.',
        noItems: 'No project records have been registered.',
        pageLabel: 'Project records pagination',
        searchLabel: 'Search project records',
        searchPlaceholder: 'Enter a keyword',
        sectionTitle: 'Project Records',
      },
    },
    supportMaterial: {
      all: 'All',
      categories: {
        EDUCATION_MATERIAL: 'Training Materials',
        TECHNICAL_DATA: 'Technical Materials',
      },
      detail: {
        attachmentEmpty: 'No file has been registered.',
        attachmentTitle: 'Attachment',
        contentLabel: 'Material body',
        download: 'Download Material',
        imageAlt: '{{title}} image {{index}}',
        imageEmpty: 'No images have been registered.',
        imageLabel: 'Images',
        invalidDescription: 'No material identifier was provided.',
        invalidTitle: 'Invalid request.',
        listAction: 'Back to list',
        listLink: 'Back to materials',
        loadingDescription: 'Loading material details.',
        loadingTitle: 'Please wait.',
        missingDescription: 'The material data could not be found.',
        missingTitle: 'Could not load the material.',
        navigationLabel: 'Previous and next material navigation',
        nextEmpty: 'No next material.',
        nextLabel: 'Next Material',
        previousEmpty: 'No previous material.',
        previousLabel: 'Previous Material',
        videoEmpty: 'No video has been registered.',
        videoLabel: 'Training material video',
        viewLabel: 'Views',
      },
      list: {
        boardCategoryHeader: 'Category',
        boardNumberHeader: 'No.',
        breadcrumb: 'Technical materials path',
        categoryFilterLabel: 'Technical material category filter',
        copyrightPrefix: 'All information and materials provided on Kookje TNC website are ',
        copyrightStrong: 'protected by copyright law',
        copyrightSuffix: '.',
        count: '{{category}} <strong>{{count}} items</strong> are registered.',
        empty: 'No technical materials match the current filters.',
        heroAlt: 'Technical materials page hero visual',
        heroDescription:
          'Find Kookje TNC technical and training materials in one place.\nThis integrated archive helps you access resources quickly and easily.',
        heroEyebrow: 'Technical Materials',
        heroTitle: 'An integrated archive\nwhere technology and experience meet',
        loadMore: 'Load more (10)',
        failedTitle: 'Could not load technical materials.',
        loadingDescription: 'Loading technical materials.',
        loadingTitle: 'Please wait.',
        noItems: 'No technical materials have been registered.',
        pageLabel: 'Technical materials pagination',
        searchLabel: 'Search technical materials',
        searchPlaceholder: 'Enter a keyword',
        sectionTitle: 'Technical Materials',
        tableDate: 'Date',
        tableTitle: 'Title',
      },
    },
    catalog: {
      category: {
        cardImageAlt: '{{title}} product image',
        cardImageUnavailable: '{{title}} image unavailable',
        cardViewDetail: '{{title}} View details',
        empty: 'No product or solution items are registered.',
        failedTitle: 'Could not load the category API.',
        fallbackDescription: 'Explore {{category}} items.',
        fallbackSpotlight: {
          maintenance: 'Maintenance',
          products: 'Products & Solutions',
          site: 'Site Application',
        },
        heroAlt: '{{eyebrow}} page hero visual',
        listFailed: 'Could not load product and solution information.',
        listLoading: 'Loading product and solution information.',
        loadingDescription: 'Waiting for the category API response.',
        loadingTitle: 'Please wait.',
      },
      detail: {
        detailPoints: 'Detail points',
        emptyDescription: 'The API response does not include detailContent.detailSection data.',
        emptyTitle: 'Detail content is empty.',
        failedTitle: 'Could not load the catalog detail API.',
        loadingDescription: 'Waiting for the catalog detail API response.',
        loadingTitle: 'Please wait.',
        sectionTitle: 'Product Details',
        switchComparisonCard: 'Switch comparison card',
        tapToCompare: 'Tap to compare',
        thumbnailAlt: '{{title}} thumbnail {{index}}',
      },
    },
    webCatalog: {
      detail: {
        download: 'Download PDF',
        empty:
          'Preview images are not ready yet. Use the PDF download button to view the original file.',
        invalidDescription: 'No web catalog identifier was provided.',
        invalidTitle: 'Invalid request.',
        listLink: 'Back to web catalogs',
        loadingDescription: 'Loading web catalog details.',
        loadingTitle: 'Please wait.',
        missingDescription: 'The web catalog data could not be found.',
        missingTitle: 'Could not load the web catalog.',
        nextPage: 'Next page',
        nextSpread: 'Next spread',
        pageImageAlt: '{{title}} page {{page}}',
        pageNavigation: 'Page navigation',
        previousSpread: 'Previous spread',
        spreadLoading: 'Preparing pages.',
      },
      list: {
        breadcrumb: 'Web catalog path',
        count: 'There are {{count}} web catalogs registered.',
        download: 'Download PDF',
        downloadLabel: '{{title}} PDF download',
        empty: 'No web catalogs match the current filters.',
        heroAlt: 'Web catalog page hero visual',
        heroDescription:
          'Find company profiles, facility brochures, and brand catalogs online.\nAccess the information you need quickly and easily from the web.',
        heroEyebrow: 'Web Catalog',
        heroTitle: 'Kookje TNC products and information\nat a glance in a web catalog',
        failedTitle: 'Could not load web catalogs.',
        loadingDescription: 'Loading web catalogs.',
        loadingTitle: 'Please wait.',
        pageLabel: 'Web catalog pagination',
        preview: 'Open preview',
        searchLabel: 'Search web catalogs',
        searchPlaceholder: 'Enter a keyword',
        sectionTitle: 'Web Catalog',
      },
    },
    mediaCoverage: {
      all: 'All',
      list: {
        breadcrumb: 'Media coverage path',
        count: 'There are {{count}} media coverage items registered.',
        empty: 'No media coverage items match the current filters.',
        heroAlt: 'Media coverage page hero visual',
        heroDescription:
          'Explore Kookje TNC news and key activities featured in the media.\nWe share coverage built on technical capability and trust.',
        heroEyebrow: 'Media Coverage',
        heroTitle: 'Kookje TNC media coverage\ndelivered through technology',
        failedTitle: 'Could not load media coverage.',
        loadingDescription: 'Loading media coverage.',
        loadingTitle: 'Please wait.',
        noItems: 'No media coverage items have been registered.',
        openLabel: 'Open {{title}} media coverage',
        pageLabel: 'Media coverage pagination',
        searchLabel: 'Search media coverage',
        searchPlaceholder: 'Enter a keyword',
        sectionTitle: 'Media Coverage',
        yearFilterLabel: 'Media coverage year filter',
        yearPlaceholder: 'Year',
      },
    },
  },
  ko: {
    common: {
      close: '닫기',
      language: {
        current: '현재 언어',
        english: 'ENG',
        korean: 'KOR',
      },
      openAllMenu: '전체 메뉴 열기',
      openMobileMenu: '모바일 메뉴 열기',
      pagination: {
        currentPage: '{{page}} 페이지, 현재 페이지',
        nextPage: '다음 페이지',
        page: '{{page}} 페이지',
        previousPage: '이전 페이지',
      },
      pageTop: '페이지 상단으로 이동',
    },
    footer: {
      builtBy: 'Built by newzest studio.',
      copyright: 'Copyright 2026 ㈜국제티엔씨. All rights reserved.',
      effectiveDate: '시행일',
      infoLabels: {
        E_MAIL: 'E-MAIL',
        FAX: 'FAX',
        TEL: 'TEL',
        address: '주소',
        businessRegistrationNumber: '사업자등록번호',
        companyName: '상호',
        representative: '대표자',
      },
      infoValues: {
        E_MAIL: 'kjtnc@kookje2001.com',
        FAX: '031-551-2253',
        TEL: '1661-8860',
        address: '경기도 남양주시 다산순환로 20, 현대프리미어캠퍼스 AA동 926~928호',
        businessRegistrationNumber: '132-81-86022',
        companyName: '㈜국제티엔씨',
        representative: '김기백',
      },
      policies: {
        emailRefusal: '이메일무단수집거부',
        privacy: '개인정보처리방침',
        terms: '이용약관',
      },
    },
    navigation: {
      dynamicCategoryDescription: '{{category}} 항목을\n카테고리 기준으로\n관리하고 노출합니다.',
      homeLinkLabel: '홈으로 이동',
      labels: {
        'CO₂ 자연냉매': 'CO₂ 자연냉매',
        CEO인사말: 'CEO인사말',
        공사실적: '공사실적',
        '공조 기계설비': '공조 기계설비',
        '공조기 리필형 필터': '공조기 리필형 필터',
        공조설비: '공조설비',
        기계설비: '기계설비',
        '기술설계 전문시공': '기술설계 전문시공',
        기술자료: '기술자료',
        '내치형 냉동 쇼케이스': '내치형 냉동 쇼케이스',
        '냉동·냉장 시스템': '냉동·냉장 시스템',
        냉동냉장: '냉동냉장',
        냉각탑: '냉각탑',
        냉난방설비: '냉난방설비',
        '경영이념·연혁': '경영이념·연혁',
        '농수산 저온창고': '농수산 저온창고',
        '모터 직결제어 시스템': '모터 직결제어 시스템',
        보일러: '보일러',
        시공사례: '시공사례',
        '오픈 쇼케이스 도어': '오픈 쇼케이스 도어',
        '운영 컨설팅': '운영 컨설팅',
        언론보도: '언론보도',
        '에너지 솔루션': '에너지 솔루션',
        위치안내: '위치안내',
        위생설비: '위생설비',
        '웹 카탈로그': '웹 카탈로그',
        '유니트 쿨러': '유니트 쿨러',
        유지보수: '유지보수',
        유통: '유통',
        자동제어: '자동제어',
        정보지원: '정보지원',
        제빙: '제빙',
        조직도: '조직도',
        터보냉동기: '터보냉동기',
        '프리미엄 와인셀러': '프리미엄 와인셀러',
        하이얼캐리어: '하이얼캐리어',
        '홈으로 이동': '홈으로 이동',
        카달로그: '카달로그',
        '특허·인증': '특허·인증',
        홍보영상: '홍보영상',
        회사소개: '회사소개',
        'CO₂ 컴프레서 랙 시스템': 'CO₂ 컴프레서 랙 시스템',
      },
      menuDescriptions: {
        co2NaturalRefrigerant: 'CO₂ 자연냉매 솔루션을\n빠르게 접근할 수 있도록\n정리했습니다.',
        company: '기업 개요와 주요 정보를\n회사소개 분류 기준에 맞춰\n재배치했습니다.',
        energySolution: '에너지 솔루션 항목을\n카테고리 기준으로\n관리하고 노출합니다.',
        informationSupport:
          '게시판과 자료실, 영상 메뉴를\n정보지원 분류 기준으로\n묶어 정리했습니다.',
        mechanicalHvac: '기계·공조 설비 서비스를\n설비 영역 기준으로\n정리했습니다.',
        refrigerationSystem: '냉동·냉장 시스템 서비스를\n적용 분야 기준으로\n정리했습니다.',
      },
    },
    quickMenu: {
      catalog: '카달로그',
      location: '위치안내',
      'promotional-video': '홍보영상',
      promotionalVideo: '홍보영상',
    },
    about: {
      certification: {
        breadcrumb: '특허·인증 경로',
        categories: {
          certification: '인증 및 수상',
          'patent-design': '특허·디자인',
        },
        empty: '등록된 특허·인증 정보가 없습니다.',
        errorTitle: '특허·인증 정보를 불러오지 못했습니다.',
        headings: {
          awards: '인증 및 수상',
          patents: '특허 및 디자인등록',
        },
        hero: {
          backgroundAlt: '국제티엔씨 특허·인증 페이지 상단 비주얼',
          description:
            '축적된 기술력은 다양한 특허와 인증으로 이어지고 있습니다.\n국제티엔씨는 검증된 기술로 신뢰를 더하고 있습니다.',
          eyebrow: '특허·인증',
          title: '기술 신뢰를 증명하는\n특허와 인증',
        },
        imageAlt: '{{title}} 증빙 이미지',
        loading: '특허·인증 정보를 불러오는 중입니다.',
      },
      greeting: {
        breadcrumb: 'CEO 인사말 경로',
        hero: {
          backgroundAlt: '국제티엔씨 CEO 인사말 페이지 상단 비주얼',
          description:
            '빠르게 대응하며 기술 경쟁력을 높이고 있습니다.\n국제티엔씨는 고객과 함께 성장하겠습니다.',
          eyebrow: 'CEO인사말',
          title: '고객 가치와 성장을 만드는\n신속 대응과 기술 혁신',
        },
        message: {
          closing: '감사합니다.',
          companyLabel: '국제티엔씨 대표',
          introHeading: '안녕하십니까! 국제티엔씨 대표 김기백입니다.',
          paragraphs: [
            '국제티엔씨는 2001년 설립 이후, 냉동·냉장 시스템 분야에서 축적해온 경험과 전문 기술력을 바탕으로 고객의 신뢰를 쌓아왔습니다.',
            '정밀한 설계와 안정적인 시공, 체계적인 유지관리뿐 아니라 기술 컨설팅, 위탁 교육, 정밀 진단에 이르기까지 고객에게 꼭 필요한 가치를 제공하기 위해 끊임없이 노력해왔습니다. 또한 유니트 쿨러와 쇼케이스 수입·판매 등 사업 영역을 확장하며 더욱 폭넓은 솔루션을 제공하고 있습니다.',
            '앞으로도 국제티엔씨는 기술에 대한 초심과 책임 있는 자세를 바탕으로, 에너지 효율 향상과 관리 비용 절감을 실현하는 신뢰받는 파트너가 되겠습니다. 고객의 미래를 함께 준비하며, 냉동·냉장 전문 기업으로서 환경과 사회에 대한 책임 또한 다하겠습니다.',
          ],
          portraitAlt: '국제티엔씨 대표 김기백',
          signatureAlt: '국제티엔씨 대표 김기백 서명',
          title: '기술과 책임으로,\n고객의 더 나은 미래를 준비합니다.',
        },
      },
      history: {
        breadcrumb: '경영이념·연혁 경로',
        empty: '등록된 연혁 정보가 없습니다.',
        errorTitle: '연혁 정보를 불러오지 못했습니다.',
        esg: {
          pillars: {
            environment:
              '탄소 및 온실가스 배출을 줄이고\n에너지 효율을 높이는 환경적 책임을 다하고',
            governance:
              '올바른 제도를 확립하여 기업이 투명성을 높여 신뢰받는 기업으로서의 사회적 책임을 다하는 기업',
            social: '임직원의 권익을 존중하여\n삶의 가치를 보장하며',
          },
          title: 'ESG 경영',
        },
        hero: {
          backgroundAlt: '국제티엔씨 연혁 페이지 상단 비주얼',
          description:
            '국제티엔씨는 분명한 철학을 바탕으로 성장해왔습니다.\n지금의 성과를 넘어 더 나은 내일을 준비하고 있습니다.',
          eyebrow: '경영이념·연혁',
          title: '지속가능한 내일을\n설계하는 국제티엔씨',
        },
        imageAlt: '{{year}}년 {{title}} 연혁 이미지',
        loadMore: '더보기',
        loading: '연혁 정보를 불러오는 중입니다.',
        practice: {
          principles: {
            fundamentals: '기본을 지키고\n원칙을 중요시하는 기업',
            people: '인재를 소중히 여기고\n능력을 발휘할 수 있는 기업',
            technology: '기술 경험에 대비한 지속적인\n기술개발과 창의적인 기업',
          },
          title: '실천 이념',
        },
        showingCount: '{{visible}} / {{total}}개 표시 중',
      },
      location: {
        breadcrumb: '사업장 위치 경로',
        companyInfo: {
          address: {
            label: '본사 주소',
            value: '경기도 남양주시 다산순환로 20, 현대프리미어캠퍼스 AA동 926-928호',
          },
          email: '이메일',
          fax: '팩스번호',
          phone: '대표번호',
          title: '회사 정보',
        },
        controls: {
          currentLocation: '현재 위치로 이동',
          geolocationBlocked:
            '현재 위치 기능은 HTTPS 또는 localhost 환경에서만 사용할 수 있습니다.',
          geolocationUnsupported: '이 브라우저는 현재 위치 기능을 지원하지 않습니다.',
          locatingApproximate:
            '현재 위치를 대략적으로 표시했습니다. 예상 오차는 약 {{accuracy}}m입니다.',
          locationAccuracyLow:
            '현재 위치 정확도가 낮아 지도를 이동하지 않았습니다. 실외에서 다시 시도해 주세요.',
          locationPermissionDenied:
            '브라우저에서 위치 권한이 차단되어 현재 위치를 가져오지 못했습니다.',
          locationTimeout: '현재 위치 확인 시간이 초과되었습니다. 잠시 후 다시 시도해 주세요.',
          locationUnavailable: '기기에서 현재 위치를 확인할 수 없습니다.',
          locationUnknown:
            '현재 위치를 가져오지 못했습니다. 브라우저 권한과 네트워크 상태를 확인해 주세요.',
          zoomIn: '지도 확대',
          zoomOut: '지도 축소',
        },
        hero: {
          backgroundAlt: '국제티엔씨 사업장 위치 페이지 상단 비주얼',
          description:
            '국제티엔씨를 편리하게 찾아오실 수 있도록 안내해드립니다.\n가까운 곳에서 언제나 고객과 함께하겠습니다.',
          eyebrow: '사업장 위치',
          title: '더 가까이 만나는\n국제티엔씨',
        },
        labels: {
          address: '주소',
          directions: '오시는 길',
          phone: '전화번호',
        },
        map: {
          apiKeyMissing: '카카오 지도 API 키가 설정되지 않아 지도를 표시할 수 없습니다.',
          geocodeFailed: '주소를 좌표로 변환하지 못했습니다. 잠시 후 다시 확인해주세요.',
          loadFailed: '카카오 지도를 불러오지 못했습니다. 네트워크나 API 설정을 확인해주세요.',
          loading: '지도를 불러오는 중입니다.',
          pending: '카카오 지도 SDK와 주소 정보를 확인하고 있습니다.',
          tabsLabel: '사업장 선택',
          title: '찾아오시는 길',
          unavailable: '지도를 표시할 수 없습니다.',
        },
        offices: {
          factory: {
            addressLine1: '경기도 남양주시 진건읍 진관산단로70번길 7, 제3동',
            busDescription: '배양리 정류장 하차 15분',
            busTitle: '9번',
            label: '공장',
          },
          guri: {
            addressLine1: '경기도 구리시 아차산로 348',
            busDescription: '구리경찰서 정류장 하차 4분',
            busTitle: '95번',
            label: '구리 지점',
            subwayDescription: '1번 출구 도보 12분',
            subwayTitle: '장자호수공원역(8호선)',
          },
          gwangju: {
            addressLine1: '광주광역시 북구 천변우하로 579-1, 중앙냉동상사',
            busDescription1: '공구의거리 정류장 하차 2분',
            busDescription2: '제2광천교 정류장 하차 6분',
            busTitle1: '송정98번',
            busTitle2: '일곡38번',
            label: '광주사업소',
          },
          headquarters: {
            addressLine1: '경기도 남양주시 다산순환로 20,',
            addressLine2: '현대프리미어캠퍼스 AA동 926-928호',
            busDescription: '도농고앞 정류장 하차 3분',
            busTitle: '95번',
            label: '본사',
            subwayDescription: '1번 출구 도보 20분',
            subwayTitle1: '도농역(경의중앙선)',
            subwayTitle2: '다산역(8호선)',
            visitSummary: '도농역·다산역에서 도보 20분, 95번 버스 정류장 하차 후 도보 3분',
          },
        },
        transport: {
          bus: '버스',
          subway: '지하철',
        },
      },
      organization: {
        breadcrumb: '조직도 경로',
        groups: {
          managementSupport: {
            label: '경영지원본부',
            teams: {
              managementAdministration: {
                items: ['인사/총무', '경리회계'],
                title: '경영관리',
              },
              strategySupport: {
                items: ['구매', '마케팅'],
                title: '전략지원',
              },
            },
          },
          mechanicalEquipment: {
            label: '기계설비사업부',
            teams: {
              facilityConstruction: {
                items: ['ESCO 공사', '설비공사', '유지보수'],
                title: '설비공사',
              },
              mechanicalSales: {
                items: ['공조설비', '냉난방설비', '솔루션영업'],
                title: '영업',
              },
            },
          },
          refrigerationEquipment: {
            label: '냉동냉장사업부',
            teams: {
              logisticsStorageSales: {
                items: ['PM', '설계 엔지니어링', '영업지원'],
                title: '물류·저장고영업',
              },
              retailSales: {
                items: ['PM', '설계 엔지니어링', '통합관제'],
                title: '리테일영업',
              },
              technicalConstruction: {
                items: ['ESCO 공사', '기술공사', '영업지원'],
                title: '기술공사',
              },
            },
          },
        },
        hero: {
          backgroundAlt: '국제티엔씨 조직도 페이지 상단 비주얼',
          description:
            '각 분야의 전문가들이 유기적으로 협력하고 있습니다.\n체계적인 조직 운영으로 더 나은 가치를 만들어가고 있습니다.',
          eyebrow: '조직도',
          title: '전문성이 함께 만드는\n조직의 힘',
        },
        leader: '대표이사',
        safety: '안전보건관리',
        title: '조직 구조',
      },
    },
    home: {
      constructionCases: {
        defaultCategory: '시공사례',
        heading: {
          description: '다양한 산업 현장에 적용된 시공 사례를 소개합니다.',
          eyebrow: 'PROJECT CASE',
          title: '국제티엔씨의 시공사례',
        },
        next: '다음 시공사례',
        previous: '이전 시공사례',
      },
      featuredEquipment: {
        heading: {
          eyebrow: 'Core Equipment Portfolio',
          title: '국제티엔씨의 주요 취급 설비',
        },
        modal: {
          close: '주요 취급 설비 모달 닫기',
          imageOrder: '설비 이미지 순서',
          nextImage: '다음 설비 이미지',
          previousImage: '이전 설비 이미지',
          progress: '{{current}} / {{total}} 이미지',
        },
        next: '다음 주요 취급 설비',
        openCard: '{{title}} 카드로 이동',
        previous: '이전 주요 취급 설비',
      },
      hero: {
        intro: {
          bottom: '지속 가능성으로',
          headingLabel: '냉동·공조를 넘어 지속 가능성으로',
          top: '냉동·공조를 넘어',
        },
        tagline: {
          firstLine: '지속 가능한 엔지니어링으로',
          secondLine: '더 시원한 내일을 만듭니다',
        },
      },
      solutionShowcase: {
        heading: {
          eyebrow: 'Solution',
          firstLine: '국제티엔씨는 비용 절감과 운영 효율을 실현하는',
          secondLineEmphasis: '차별화된 솔루션을 제안',
          secondLineSuffix: '합니다',
        },
        mobileNavigationLabel: '모바일 국제티엔씨 솔루션 슬라이드',
        navigationLabel: '국제티엔씨 솔루션 슬라이드',
        slides: {
          'energy-saving': {
            description:
              '현장 운전 특성에 최적화된 Fan·Pump 인버터 제어 기술로\n전력 소비 절감과 설비 효율 고도화를 동시에 구현합니다',
            imageAlt: '에너지 최적화 솔루션 배경 이미지',
            mobileImageAlt: '에너지 최적화 솔루션 모바일 배경 이미지',
            title: '에너지 최적화 솔루션',
          },
          'fire-prevention': {
            description:
              '화재 위험 신호를 실시간 모니터링하는 경보 알림 시스템으로\n사전 예방형 안전관리 체계와 신속한 대응 환경을 구축합니다',
            imageAlt: '화재예방 안전 솔루션 배경 이미지',
            mobileImageAlt: '화재예방 안전 솔루션 모바일 배경 이미지',
            title: '화재예방 안전 솔루션',
          },
          'hvac-system': {
            description:
              '열부하와 운전 조건을 정밀 분석한 최적의 GHP·EHP 시스템으로\n공조설비의 기술 컨설팅·정밀 설계·책임 시공을 수행합니다',
            imageAlt: '공조설비 시스템 엔지니어링 배경 이미지',
            mobileImageAlt: '공조설비 시스템 엔지니어링 모바일 배경 이미지',
            title: '공조설비 시스템\u00A0엔지니어링',
          },
          'mechanical-engineering': {
            description:
              '축적된 기술 역량으로 공정 조건과 현장 환경을 정밀 반영한\n기계설비의 컨설팅·정밀 설계·책임 시공을 안정적으로 수행합니다',
            imageAlt: '기계설비 종합 엔지니어링 배경 이미지',
            mobileImageAlt: '기계설비 종합 엔지니어링 모바일 배경 이미지',
            title: '기계설비 종합\u00A0엔지니어링',
          },
        },
      },
      businessInquiry: {
        categoryOptions: {
          energySolution: '에너지 솔루션',
          mechanicalHvac: '공조 기계설비',
          other: '기타',
          refrigerationSystem: '냉동·냉장 시스템',
          serviceMaintenance: '유지보수/서비스',
        },
        description:
          '유통, 물류, 호텔 등 다양한 산업 군의 고객사와 협력적 파트너십 관계를 구축하고 있습니다.',
        effectiveDateLabel: '시행일',
        errors: {
          categoryLoadFailed: '문의 종류를 불러오지 못했습니다.',
          invalidCategory: '유효한 문의 종류를 선택해주세요.',
          submitFailed: '문의 접수에 실패했습니다. 잠시 후 다시 시도해주세요.',
        },
        eyebrow: 'Business Inquiry',
        fields: {
          category: {
            label: '문의 종류',
            placeholder: '문의 종류를 선택해주세요',
          },
          companyName: {
            label: '회사명',
            placeholder: '회사명을 입력해주세요',
          },
          contactName: {
            label: '담당자명',
            placeholder: '담당자명을 입력해주세요',
          },
          department: {
            label: '직책/부서',
            placeholder: '직책/부서를 입력해주세요',
          },
          email: {
            label: '이메일',
            placeholder: '이메일을 입력해주세요',
          },
          message: {
            label: '문의내용',
            placeholder: '현장 조건, 필요한 설비 범위, 일정, 검토 요청사항 등 자유롭게 적어주세요',
          },
          phone: {
            label: '연락처',
            placeholder: '연락처를 입력해주세요',
          },
        },
        marketingConsentLabel: '마케팅 정보 수신 동의',
        marketingNotice:
          '신규 서비스, 이벤트, 뉴스레터 등 마케팅 정보를 받아보실 수 있으며, 동의하지 않아도 문의 접수에는 제한이 없습니다.',
        optionalTag: '[선택]',
        partnerLogosLabel: '주요 고객사 로고',
        privacyConsentLabel: '개인정보 수집 및 이용 동의',
        privacyLink: '개인정보처리방침 보기',
        privacyModalClose: '개인정보처리방침 닫기',
        privacyNotice:
          '문의 접수를 위해 회사명, 담당자명, 연락처, 이메일, 문의 내용을 수집·이용합니다.\n수집된 정보는 문의 응대와 회신을 위해 사용되며, 내부 기준과 관련 법령에 따라 보관됩니다.\n필수 동의를 거부하실 경우 문의 접수가 제한될 수 있습니다.',
        requiredTag: '[필수]',
        resetLabel: '새 문의 작성하기',
        submitLabel: '문의 접수하기',
        submittingLabel: '접수 중...',
        successDescription: '담당자가 영업일 기준 1일 이내에 1차 회신을 드립니다.',
        successTitle: '문의가 접수되었습니다',
        title: '국제티엔씨 사업 문의',
        validation: {
          agreePrivacy: '개인정보 수집 및 이용에 동의해주세요.',
          category: '문의 종류를 선택해주세요.',
          companyName: '회사명을 입력해주세요.',
          contactName: '담당자명을 입력해주세요.',
          email: '이메일을 입력해주세요.',
          emailFormat: '올바른 이메일 형식을 입력해주세요.',
          message: '문의내용을 입력해주세요.',
          phone: '연락처를 입력해주세요.',
          phoneFormat: '올바른 연락처 형식을 입력해주세요.',
        },
      },
    },
    promotionalVideo: {
      all: '전체',
      category: '홍보영상',
      detail: {
        invalidDescription: '홍보영상 식별자가 전달되지 않았습니다.',
        invalidTitle: '잘못된 요청입니다.',
        listAction: '목록보기',
        listLink: '홍보영상 목록보기',
        loadingDescription: '홍보영상을 불러오는 중입니다.',
        loadingTitle: '잠시만 기다려 주세요.',
        meta: '[홍보영상]',
        missingDescription: '홍보영상 데이터를 찾지 못했습니다.',
        missingTitle: '홍보영상을 불러오지 못했습니다.',
        navigationLabel: '이전 다음 홍보영상 이동',
        nextEmpty: '다음 영상이 없습니다.',
        nextLabel: '다음 영상',
        playerLabel: '{{title}} 영상 재생 영역',
        previousEmpty: '이전 영상이 없습니다.',
        previousLabel: '이전 영상',
        videoFallback: '유효한 YouTube URL이 필요합니다.',
        youtubePlayerLabel: '{{title}} YouTube 플레이어',
      },
      list: {
        breadcrumb: '홍보영상 경로',
        count: '전체 {{count}}건의 자료가 등록되어 있습니다.',
        empty: '조건에 맞는 홍보영상이 없습니다.',
        filterLabel: '홍보영상 구분 필터',
        heroAlt: '홍보영상 페이지 상단 비주얼',
        heroDescription:
          '국제티엔씨의 브랜드와 기술력을 다양한 영상으로 확인하실 수 있습니다.\n제품과 사업의 가치를 보다 생생하고 직관적으로 만나보실 수 있습니다.',
        heroEyebrow: '홍보영상',
        heroTitle: '국제티엔씨의 기술과 가치를 담은\n홍보영상 아카이브',
        loadingDescription: '홍보영상 목록을 불러오는 중입니다.',
        loadingTitle: '잠시만 기다려 주세요.',
        next: '다음',
        pageLabel: '홍보영상 페이지 이동',
        previous: '이전',
        searchLabel: '홍보영상 검색',
        searchPlaceholder: '검색어를 입력하세요',
        sectionTitle: '홍보영상',
        thumbnailAlt: '{{title}} 홍보영상 썸네일',
        viewDetail: '{{title}} 상세보기',
      },
    },
    constructionCase: {
      all: '전체',
      categories: {
        default: '시공사례',
        '기계·공조 설비': '기계·공조 설비',
        '냉동·냉장 설비': '냉동·냉장 설비',
        '식품 매장 도어': '식품 매장 도어',
        시공사례: '시공사례',
        '열교환기 납품': '열교환기 납품',
        '유틸리티 배관': '유틸리티 배관',
        환경개선공사: '환경개선공사',
      },
      detail: {
        categoryFallback: '시공사례',
        clientLabel: '발주처',
        featureTitle: '시공 포인트 · 특징',
        galleryNext: '다음 시공 사진',
        galleryPrevious: '이전 시공 사진',
        galleryTitle: '시공 사진',
        invalidDescription: '시공사례 식별자가 전달되지 않았습니다.',
        invalidTitle: '잘못된 요청입니다.',
        listAction: '목록보기',
        listLink: '시공사례 목록으로 돌아가기',
        loadingDescription: '시공사례 상세 정보를 불러오는 중입니다.',
        loadingTitle: '잠시만 기다려 주세요.',
        locationFallback: '현장 정보 확인 중',
        locationLabel: '현장 위치',
        missingDescription: '시공사례 데이터를 찾지 못했습니다.',
        missingTitle: '시공사례를 불러오지 못했습니다.',
        periodLabel: '공사기간',
        photoAlt: '{{title}} 시공 사진 {{index}}',
        scopeTitle: '공사 범위',
        summaryTitle: '시공사례',
      },
      list: {
        breadcrumb: '시공사례 경로',
        categoryFilterLabel: '시공사례 구분 필터',
        count: '전체 {{count}}건의 자료가 등록되어 있습니다.',
        empty: '조건에 맞는 시공사례가 없습니다.',
        heroAlt: '시공사례 페이지 상단 비주얼',
        heroDescription:
          '국제티엔씨가 수행해온 다양한 프로젝트와 시공 사례를 확인하실 수 있습니다.\n축적된 경험과 기술력을 바탕으로 완성한 실적을 소개해드립니다.',
        heroEyebrow: '시공사례',
        heroTitle: '신뢰로 완성한\n국제티엔씨의 시공 사례',
        loadingDescription: '시공사례 목록을 불러오는 중입니다.',
        loadingTitle: '잠시만 기다려 주세요.',
        noItems: '등록된 시공사례가 없습니다.',
        pageLabel: '시공사례 페이지 이동',
        searchLabel: '시공사례 검색',
        searchPlaceholder: '검색어를 입력하세요',
        sectionTitle: '시공사례',
        yearFilterLabel: '시공사례 연도 필터',
        yearPlaceholder: '연도',
      },
      meta: {
        client: '발주처',
      },
    },
    projectRecord: {
      all: '전체',
      categories: {
        공공기관: '공공기관',
        교육기관: '교육기관',
        물류기업: '물류기업',
        유통기업: '유통기업',
        일반기업: '일반기업',
      },
      list: {
        breadcrumb: '공사실적 경로',
        categoryFilterLabel: '공사실적 구분 필터',
        count: '전체 {{count}}건의 자료가 등록되어 있습니다.',
        empty: '조건에 맞는 공사실적이 없습니다.',
        headers: {
          category: '구분',
          client: '발주처',
          name: '공사명',
          number: '번호',
          period: '공사기간',
        },
        heroAlt: '공사실적 페이지 상단 비주얼',
        heroDescription:
          '국제티엔씨가 수행해온 다양한 프로젝트와 공사실적을 확인하실 수 있습니다.\n축적된 경험과 기술력을 바탕으로 완성한 실적을 소개해드립니다.',
        heroEyebrow: '공사실적',
        heroTitle: '신뢰로 완성한\n국제티엔씨의 공사실적',
        loadMore: '더보기 (10개)',
        failedTitle: '공사실적을 불러오지 못했습니다.',
        loadingDescription: '공사실적 목록을 불러오는 중입니다.',
        loadingTitle: '잠시만 기다려 주세요.',
        noItems: '등록된 공사실적이 없습니다.',
        pageLabel: '공사실적 페이지 이동',
        searchLabel: '공사실적 검색',
        searchPlaceholder: '검색어를 입력하세요',
        sectionTitle: '공사 실적',
      },
    },
    supportMaterial: {
      all: '전체',
      categories: {
        EDUCATION_MATERIAL: '교육자료',
        TECHNICAL_DATA: '기술자료',
      },
      detail: {
        attachmentEmpty: '등록된 자료가 없습니다.',
        attachmentTitle: '첨부파일',
        contentLabel: '자료 본문',
        download: '자료 다운로드',
        imageAlt: '{{title}} 이미지 {{index}}',
        imageEmpty: '등록된 이미지가 없습니다.',
        imageLabel: '이미지',
        invalidDescription: '자료 식별자가 전달되지 않았습니다.',
        invalidTitle: '잘못된 요청입니다.',
        listAction: '목록보기',
        listLink: '자료 목록으로 돌아가기',
        loadingDescription: '자료 상세 정보를 불러오는 중입니다.',
        loadingTitle: '잠시만 기다려 주세요.',
        missingDescription: '자료 데이터를 찾지 못했습니다.',
        missingTitle: '자료를 불러오지 못했습니다.',
        navigationLabel: '이전 다음 자료 이동',
        nextEmpty: '다음 자료가 없습니다.',
        nextLabel: '다음 자료',
        previousEmpty: '이전 자료가 없습니다.',
        previousLabel: '이전 자료',
        videoEmpty: '등록된 영상이 없습니다.',
        videoLabel: '교육자료 영상',
        viewLabel: '조회수',
      },
      list: {
        boardCategoryHeader: '구분',
        boardNumberHeader: '번호',
        breadcrumb: '기술자료 경로',
        categoryFilterLabel: '기술자료 구분 필터',
        copyrightPrefix: '(주)국제티엔씨의 홈페이지에서 제공하는 모든 정보 및 자료는 ',
        copyrightStrong: '저작권법에 의하여 보호',
        copyrightSuffix: '받고 있습니다.',
        count: '{{category}} <strong>{{count}}건</strong>의 자료가 등록되어 있습니다.',
        empty: '조건에 맞는 기술자료가 없습니다.',
        heroAlt: '기술자료 페이지 상단 비주얼',
        heroDescription:
          '국제티엔씨의 기술자료와 교육자료를 한곳에서\n쉽고 빠르게 확인할 수 있는 통합 자료실입니다.',
        heroEyebrow: '기술 자료',
        heroTitle: '기술과 경험이 모이는\n통합 자료실',
        loadMore: '더보기 (10개)',
        failedTitle: '기술자료를 불러오지 못했습니다.',
        loadingDescription: '기술자료 목록을 불러오는 중입니다.',
        loadingTitle: '잠시만 기다려 주세요.',
        noItems: '등록된 기술자료가 없습니다.',
        pageLabel: '기술자료 페이지 이동',
        searchLabel: '기술자료 검색',
        searchPlaceholder: '검색어를 입력하세요',
        sectionTitle: '기술 자료',
        tableDate: '등록일',
        tableTitle: '제목',
      },
    },
    catalog: {
      category: {
        cardImageAlt: '{{title}} 제품 이미지',
        cardImageUnavailable: '{{title}} 이미지 없음',
        cardViewDetail: '{{title}} 자세히 보기',
        empty: '등록된 제품·솔루션 항목이 없습니다.',
        failedTitle: '카테고리 API를 불러오지 못했습니다.',
        fallbackDescription: '{{category}} 항목을 확인할 수 있습니다.',
        fallbackSpotlight: {
          maintenance: '유지관리',
          products: '제품·솔루션',
          site: '현장 적용',
        },
        heroAlt: '{{eyebrow}} 페이지 상단 비주얼',
        listFailed: '제품·솔루션 정보를 불러오지 못했습니다.',
        listLoading: '제품·솔루션 정보를 불러오는 중입니다.',
        loadingDescription: '카테고리 API 응답을 기다리는 중입니다.',
        loadingTitle: '잠시만 기다려 주세요.',
      },
      detail: {
        detailPoints: '상세 포인트',
        emptyDescription: 'API 응답에 detailContent.detailSection 데이터가 없습니다.',
        emptyTitle: '상세 콘텐츠가 비어 있습니다.',
        failedTitle: '사업영역 상세 API를 불러오지 못했습니다.',
        loadingDescription: '사업영역 상세 API 응답을 기다리는 중입니다.',
        loadingTitle: '잠시만 기다려 주세요.',
        sectionTitle: '제품 상세정보',
        switchComparisonCard: '비교 카드 전환',
        tapToCompare: '터치해서 비교 전환',
        thumbnailAlt: '{{title}} 썸네일 {{index}}',
      },
    },
    webCatalog: {
      detail: {
        download: 'PDF 다운로드',
        empty:
          '미리보기 이미지가 아직 준비되지 않았습니다. PDF 다운로드 버튼으로 원본 파일을 확인하실 수 있습니다.',
        invalidDescription: '웹카탈로그 식별자가 전달되지 않았습니다.',
        invalidTitle: '잘못된 요청입니다.',
        listLink: '웹카탈로그 목록으로 돌아가기',
        loadingDescription: '웹카탈로그 상세 정보를 불러오는 중입니다.',
        loadingTitle: '잠시만 기다려 주세요.',
        missingDescription: '웹카탈로그 데이터를 찾지 못했습니다.',
        missingTitle: '웹카탈로그를 불러오지 못했습니다.',
        nextPage: '다음 페이지',
        nextSpread: '다음 펼침 페이지',
        pageImageAlt: '{{title}} {{page}}페이지',
        pageNavigation: '페이지 이동',
        previousSpread: '이전 펼침 페이지',
        spreadLoading: '페이지를 준비하고 있습니다.',
      },
      list: {
        breadcrumb: '웹카탈로그 경로',
        count: '전체 {{count}}건의 자료가 등록되어 있습니다.',
        download: 'PDF 다운로드',
        downloadLabel: '{{title}} PDF 다운로드',
        empty: '조건에 맞는 웹카탈로그가 없습니다.',
        heroAlt: '웹카탈로그 페이지 상단 비주얼',
        heroDescription:
          '회사 소개부터 설비 브로슈어, 브랜드 카탈로그까지\n필요한 정보를 웹에서 쉽고 빠르게 확인하실 수 있습니다.',
        heroEyebrow: '웹 카탈로그',
        heroTitle: '국제티엔씨의 제품과 정보를\n한눈에 보는 웹 카탈로그',
        failedTitle: '웹카탈로그를 불러오지 못했습니다.',
        loadingDescription: '웹카탈로그 목록을 불러오는 중입니다.',
        loadingTitle: '잠시만 기다려 주세요.',
        pageLabel: '웹카탈로그 페이지 이동',
        preview: '펼쳐보기',
        searchLabel: '웹카탈로그 검색',
        searchPlaceholder: '검색어를 입력하세요',
        sectionTitle: '웹 카탈로그',
      },
    },
    mediaCoverage: {
      all: '전체',
      list: {
        breadcrumb: '언론보도 경로',
        count: '전체 {{count}}건의 자료가 등록되어 있습니다.',
        empty: '조건에 맞는 언론보도가 없습니다.',
        heroAlt: '언론보도 페이지 상단 비주얼',
        heroDescription:
          '국제티엔씨의 최신 소식과 언론에 소개된 주요 활동을 확인하실 수 있습니다.\n기술력과 신뢰를 바탕으로 한 다양한 보도 내용을 소개합니다.',
        heroEyebrow: '언론 보도',
        heroTitle: '기술로 전해지는\n국제티엔씨의 언론보도',
        failedTitle: '언론보도를 불러오지 못했습니다.',
        loadingDescription: '언론보도 목록을 불러오는 중입니다.',
        loadingTitle: '잠시만 기다려 주세요.',
        noItems: '등록된 언론보도가 없습니다.',
        openLabel: '{{title}} 보도자료 열기',
        pageLabel: '언론보도 페이지 이동',
        searchLabel: '언론보도 검색',
        searchPlaceholder: '검색어를 입력하세요',
        sectionTitle: '언론보도',
        yearFilterLabel: '언론보도 연도 필터',
        yearPlaceholder: '연도',
      },
    },
  },
} as const;
